module.exports = __webpack_public_path__ + "img/logo-dpd.da891189.svg";